import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.tasks')
  .factory('$task', TaskObjectFactory);

/* @ngInject */
function TaskObjectFactory($bringozFactory: $bringozFactory,
                           tasksAPI: BringozApi,
                           Tasks_DS: DataStoreConfig,
                           Tasks_PN: PushNotificationsConfig) {
  function $task(id: string) {
    return $bringozFactory(id, tasksAPI, Tasks_DS, Tasks_PN);
  }

  return $task;
}
